import MarkDownRenderer from '../../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
## **Request Headers**

Customize headers such as **Content-Type**, **Authorization**, and custom headers.  
These headers are sent along with your request and are crucial for APIs that require
authentication tokens or specific content types.

![Request Headers in HawkClient](/send-requests/Headers.png)
`;

const HeadersTab = () => {
    return (
        <MarkDownRenderer
            title="Request Headers"
            markDownText={markdownContent}
        />
    );
};

export default HeadersTab;
